<template>
  <v-card class="w-100 pa-5 px-6">
    <v-row dir="ltr">
      <v-col cols="1">
        <div
          class="mainTable icon-box flex-row-center-center"
          @click="open = !open"
        >
          <v-icon color="text">
            {{ open ? "mdi-chevron-up" : "mdi-chevron-down" }}
          </v-icon>
        </div>
      </v-col>
      <v-col cols="11" dir="rtl">
        <div class="flex-row-start-center gap-2">
          <div class="text-body-2 text--text">{{ $t("dateTime") }}:</div>
          <div class="text-body-2 text--text">
            {{ time }}
          </div>
        </div>
      </v-col>
      <v-col cols="12" v-if="open">
        <div class="flex-col-start-start gap-4 w-100">
          <HistoryInputCard v-if="record" :record="record" />
          <CompositionResult
            :composition="balanceData.composition"
            :req-air="record ? record.output.reqAir : null"
          />
          <ProductResult :product="balanceData.product" />
          <OtherResult title="Reformer" :tableData="balanceData.reformer" />
          <OtherResult
            title="Recuperator"
            :tableData="balanceData.recuperator"
          />
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import moment from "jalali-moment";
import CompositionResult from "@/components/balance/CompositionResult.vue";
import ProductResult from "@/components/balance/ProductResult.vue";
import OtherResult from "@/components/balance/OtherResult.vue";
import HistoryInputCard from "./history.input.card.vue";

export default {
  name: "BalanceHistoryCard",

  props: {
    balanceData: { type: Object, required: true },
    record: { type: Object, required: false },
  },

  data() {
    return {
      open: false,
    };
  },

  computed: {
    time() {
      return moment(this.balanceData.time).format("jDD jMMMM jYYYY - hh:mm");
    },
  },

  components: {
    CompositionResult,
    ProductResult,
    OtherResult,
    HistoryInputCard,
  },
};
</script>

<style scoped>
.icon-box {
  border-radius: 4px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
</style>
